module.exports = __webpack_public_path__ + "img/8_deal_architech.13481b28.png";